export const constructorColorMap = {
  1: "#FF8700", // McLaren
  131: "#A7A7A7", // Mercedes
  3: "#37A7D8", // Williams
  6: "#FF1801", // Ferrari
  9: "#1B3F8B", // Red Bull
  214: "#0093C7", // Alpine
  210: "#4B4B4B", // Haas
  51: "#960000", // Alfa Romeo
  213: "#20394C", // AlphaTauri
  117: "#2D8265", // Aston Martin
  4: "#000000", // Renault
  5: "#A39064", // Toro Rosso
  10: "#00A85C", // Force India
  211: "#EC0374", // Racing Point
  15: "#DE3126", // Sauber
  215: "#1A1F71", // RB
};

export const constructorNameColorMap = {
  McLaren: "#FF8700",
  Mercedes: "#A7A7A7",
  Williams: "#37A7D8",
  Ferrari: "#FF1801",
  "Red Bull": "#1B3F8B",
  Alpine: "#0093C7",
  Haas: "#4B4B4B",
  "Alfa Romeo": "#960000",
  AlphaTauri: "#20394C",
  "Aston Martin": "#2D8265",
  Renault: "#000000",
  "Toro Rosso": "#A39064",
  "Force India": "#00A85C",
  "Racing Point": "#EC0374",
  Sauber: "#DE3126",
  RB: "#1A1F71",
};
